function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M40.0001 0.00016313C62.0914 0.00016313 80 17.9088 80 40.0001C80 62.0914 62.0914 80 40.0001 80C17.9088 80 0.000165915 62.0914 0.000165915 40.0001C-0.0626935 17.9714 17.7439 0.0630226 39.7724 0.00016313C39.8483 -5.43767e-05 39.9242 -5.43767e-05 40.0001 0.00016313Z",
  fill: "#FF0000",
  fillOpacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M40.0002 5.40554C59.1062 5.40554 74.5947 20.8941 74.5947 40.0001C74.5947 59.106 59.1062 74.5946 40.0002 74.5946C20.8942 74.5946 5.40566 59.106 5.40566 40.0001C5.3513 20.9483 20.7516 5.4599 39.8032 5.40554C39.8689 5.40535 39.9345 5.40535 40.0002 5.40554Z",
  fill: "#FF0000",
  fillOpacity: 0.05
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40 10.8109C56.1207 10.8109 69.1892 23.8658 69.1892 39.9698C69.1892 56.0737 56.1207 69.1286 40 69.1286C23.8794 69.1286 10.8109 56.0737 10.8109 39.9698C10.765 23.9115 23.7591 10.8567 39.8339 10.8109C39.8893 10.8108 39.9446 10.8108 40 10.8109Z",
  fill: "#FF0000"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.8764 32.1236L32.1235 47.8765M32.1235 32.1236L47.8764 47.8765",
  stroke: "#FEFFFE",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDrafstCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafstCancel);
export default __webpack_public_path__ + "static/media/drafstCancel.c0e8b4c6.svg";
export { ForwardRef as ReactComponent };